import type { Paginated } from '@/interfaces/Paginate';
import type { AssetOpportunity } from '@/modules/Asset/interface/Opportunity';
import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getAssetsOpportunities = async (
  url: string,
  params?: GetAssetsOpportunitiesParams
) => {
  const { data } = await api.get<Paginated<AssetOpportunity>>(url, { params });
  return data.data;
};

export const useGetAssetsOpportunities = (
  params?: GetAssetsOpportunitiesParams
) => {
  const { data: session } = useSession();

  const url =
    session && session.access_token
      ? apiConfig.routes.assets.opportunities
      : apiConfig.routes.assets.opportunitiesPublic;

  return useQuery({
    queryKey: ['assets', 'opportunities', { ...params }, url],
    queryFn: () => getAssetsOpportunities(url, params),
  });
};

type GetAssetsOpportunitiesParams = {
  page?: number;
  limit?: number;
};
